import { Col, Row, Divider, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { CONST } from '../../../constants/constant';
import InputComponent from '../../common/InputComponent/InputComponent';

const QuotationHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-lg md:px-40 md:py-32 md:gap-24 p-16 gap-16 flex flex-col">
      {/* Company and Customer Info */}
      <div className="flex flex-col self-stretch items-end justify-start gap-24">
        <div className="grid md:grid-cols-2 grid-cols-1 items-end self-stretch">
          <img
            src="/assets/logo/new_logo_fitta.png"
            alt=""
            className="lg:h-48 md:h-32 h-24 object-contain"
          />
          <h3 className="hidden lg:flex text-headline-small font-bold text-black-medium m-0">
            {t('quotation.customerInfo', 'Thông Tin Khách Hàng')}
          </h3>
        </div>
        <div className="md:grid md:grid-cols-2 flex flex-col self-stretch items-start justify-end">
          <div className="md:grid md:grid-rows-5 flex flex-col">
            <p className="inline-block gap-8 items-start">
              <span className="text-title-small font-semibold whitespace-nowrap min-h-32">
                Địa chỉ:
              </span>
              <span className="text-body-large font-normal">
                {t(
                  'Constant.50 9A Street, Trung Son Residential Area, Binh Chanh, Ho Chi Minh City, Vietnam'
                )}
              </span>
            </p>
            <p className="inline-block gap-8 items-start">
              <span
                className="text-title-small font-semibold whitespace-nowrap min-h-32 inline-flex"
                inline-flex
              >
                Điện thoại:
              </span>
              <span className="text-body-large font-normal">
                {CONST.laNhaPhone}
              </span>
            </p>
            <p className="inline-block gap-8 items-start">
              <span className="text-title-small font-semibold whitespace-nowrap min-h-32 inline-flex">
                Email:
              </span>
              <span className="text-body-large font-normal">
                {CONST.laNhaEmail}
              </span>
            </p>
            <p className="inline-block gap-8 items-start">
              <span
                className="text-title-small font-semibold whitespace-nowrap min-h-32 inline-flex"
                inline-flex
              >
                Website:
              </span>
              <span className="text-body-large font-normal">
                {CONST.laNhaWebsite}
              </span>
            </p>
            <p className="inline-block gap-8 items-start">
              <span
                className="text-title-small font-semibold whitespace-nowrap min-h-32 inline-flex"
                inline-flex
              >
                Mã số thuế:
              </span>
              <span className="text-body-large font-normal">
                {CONST.laNhaTaxId}
              </span>
            </p>
          </div>

          <div className="grid grid-rows-4">
            <Form.Item
              layout="horizontal"
              name="customerName"
              label={
                <span className="text-title-small font-semibold text-black-high">
                  {t('quotation.customerName', 'Tên')}
                </span>
              }
              className="flex items-center [&_.ant-form-item-label]:pb-0"
            >
              <InputComponent
                placeholder="Nhập tên khách hàng"
                className="border-none w-[200px] [&.ant-input-outlined]:hover:border-none [&.ant-input-outlined]:focus:border-none text-body-large font-normal"
              />
            </Form.Item>
            <Form.Item
              layout="horizontal"
              name="customerPhone"
              label={
                <span className="text-title-small font-semibold text-black-high">
                  {t('quotation.customerPhone', 'Điện thoại')}
                </span>
              }
              className="flex items-center [&_.ant-form-item-label]:pb-0"
            >
              <InputComponent
                placeholder="Nhập số điện thoại"
                className="border-none w-[200px] [&.ant-input-outlined]:hover:border-none [&.ant-input-outlined]:focus:border-none text-body-large font-normal"
              />
            </Form.Item>
            <Form.Item
              layout="horizontal"
              name="customerEmail"
              label={
                <span className="text-title-small font-semibold text-black-high">
                  {t('quotation.customerEmail', 'Email')}
                </span>
              }
              className="flex items-center [&_.ant-form-item-label]:pb-0"
            >
              <InputComponent
                placeholder="Nhập email"
                className="border-none w-[200px] [&.ant-input-outlined]:hover:border-none [&.ant-input-outlined]:focus:border-none text-body-large font-normal"
              />
            </Form.Item>
            <Form.Item
              layout="horizontal"
              name="customerAddress"
              label={
                <span className="text-title-small font-semibold text-black-high">
                  {t('quotation.customerAddress', 'Địa chỉ')}
                </span>
              }
              className="flex items-center [&_.ant-form-item-label]:pb-0"
            >
              <InputComponent
                placeholder="Nhập địa chỉ"
                className="border-none w-[200px] [&.ant-input-outlined]:hover:border-none [&.ant-input-outlined]:focus:border-none text-body-large font-normal"
              />
            </Form.Item>
          </div>
        </div>
      </div>

      <Divider />

      {/* Title */}
      <div className="text-center">
        <h1 className="text-headline-large md:text-headline-medium font-bold text-black-high m-0 mb-2">
          {t('quotation.title', 'BÁO GIÁ NỘI THẤT')}
        </h1>
        <p className="text-black-low m-0">
          {new Date().toLocaleDateString('vi-VN', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
        </p>
      </div>
    </div>
  );
};

export default QuotationHeader;
